import React, { useState, useEffect } from 'react';
import ProjectCard from './ProjectCard';
import ProjectViewer from './ProjectViewer';
import tekyuProjects from '../data/tekyuProjects';

const ProjectsTab = ({ isPro }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectProgress, setProjectProgress] = useState({});

  // Load progress for all projects
  useEffect(() => {
    const progress = {};
    tekyuProjects.forEach((project) => {
      const saved = localStorage.getItem(`tekyu-project-${project.id}`);
      if (saved) {
        const parsed = JSON.parse(saved);
        const completedSteps = project.steps.filter((step) => {
          const stepTasks = parsed.completedTasks?.[step.id] || [];
          return step.content.tasks?.length === stepTasks.length;
        });
        progress[project.id] = {
          completedSteps: completedSteps.map((s) => s.id),
          ...parsed,
        };
      }
    });
    setProjectProgress(progress);
  }, [selectedProject]);

  if (selectedProject) {
    return (
      <ProjectViewer
        project={selectedProject}
        onBack={() => setSelectedProject(null)}
      />
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ color: 'white', fontSize: '28px', fontWeight: '700', marginBottom: '8px' }}>
          Hands-On Projects
        </h1>
        <p style={{ color: '#9ca3af', fontSize: '16px', maxWidth: '600px' }}>
          Build real-world security skills with guided projects. Each project includes step-by-step instructions, code samples, and knowledge checks.
        </p>
      </div>

      {/* Project grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
          gap: '20px',
        }}
      >
        {tekyuProjects.map((project) => (
          <ProjectCard
            key={project.id}
            project={project}
            isPro={isPro}
            onSelect={setSelectedProject}
            progress={projectProgress[project.id]}
          />
        ))}
      </div>

      {/* Skills summary */}
      <div style={{ marginTop: '48px', borderTop: '1px solid #374151', paddingTop: '32px' }}>
        <h2 style={{ color: 'white', fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>
          Skills You'll Learn
        </h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {[...new Set(tekyuProjects.flatMap((p) => p.skills))].map((skill, index) => (
            <span
              key={index}
              style={{
                backgroundColor: '#374151',
                color: '#d1d5db',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
              }}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsTab;
